// @ts-nocheck TODO: fix types for the entire file
import styled, { StyledComponent } from '@emotion/styled';
import {
  Select as MuiSelect,
  FormHelperText as MuiHelperText,
  FormHelperTextProps,
  FormLabel,
} from '@mui/material';
import { CustomIcon, CustomIconProps } from 'components/CustomIcon';
import { theme } from 'theme';
import hexToRGBA from 'theme/hexToRGBA';
import pxToEm from 'theme/pxToEm';
import { MBSelectProps } from './MBSelect.types';

export const selectSizes = {
  height: {
    small: pxToEm(40),
    medium: pxToEm(48),
    large: pxToEm(64),
  },
  padding: {
    small: `${pxToEm(6)} ${pxToEm(16)}`,
    medium: `${pxToEm(12)} ${pxToEm(16)}`,
    large: `${pxToEm(12)} ${pxToEm(20)}`,
  },
};

export const Wrapper = styled('div')<Partial<MBSelectProps>>`
  .MuiInput-root,
  .MuiOutlinedInput-root,
  .MuiFilledInput-root {
    height: ${(props) =>
      props.selectSize != null ? selectSizes.height[props.selectSize] : 'auto'};
    div[role='button'] > .MuiListItemIcon-root {
      display: none;
    }
  }

  .MuiInput-underline {
    &:before {
      border-bottom: ${({ theme }) =>
        `1px solid ${theme.palette.secondary?.light}`};
    }
  }

  .MuiOutlinedInput-notchedOutline > legend {
    height: 20px;
    span {
      opacity: 1;
    }
  }
  .Mui-focused {
    & .MuiOutlinedInput-notchedOutline {
      border-width: 1px !important;
      border-color: ${theme.palette.primary.dark} !important;
    }
  }
  .Mui-error {
    .MuiOutlinedInput-notchedOutline {
      background-color: ${({ theme: { palette } }) =>
        hexToRGBA(palette.error.main, 0.15)};
    }
  }

  .MuiMenuItem-root {
    min-width: ${(props) => pxToEm(props.itemsMinWidth ?? 1)};
  }
  .MuiInputBase-root,
  .MuiSelect-select,
  .MuiSelect-select ~ fieldset {
    ${(props) =>
      props.unstyled
        ? `
    border: 0 !important;
    background: none !important;
    &:before, &:after {
      display: none !important;
    }
    `
        : ''};
  }
`;

// TODO: refactor without type assertion, or add comment
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const Label = styled(FormLabel as any)`
  margin-bottom: ${pxToEm(8)};
  font-size: ${pxToEm(12)};
  line-height: ${pxToEm(20)};
  font-weight: 700;
  display: block;
`;

// TODO: refactor without type assertion, or add comment
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const Icon = styled(CustomIcon)`
  position: absolute;
  right: ${pxToEm(12)};
  top: calc(50% - 0.8em) !important;
  pointer-events: none;
  user-select: none;
  display: inline-block;
  flex-shrink: 0;
  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: ${pxToEm(12)} !important;
  }
` as React.FC<React.PropsWithChildren<CustomIconProps>>;

export const HelperText: StyledComponent<FormHelperTextProps> = styled(
  MuiHelperText,
)`
  margin-left: ${pxToEm(2)};
  margin-right: ${pxToEm(2)};
  font-size: ${pxToEm(12)};
  line-height: ${pxToEm(20)};
  font-weight: 400;
  margin-top: ${pxToEm(4)};
`;

// @ts-ignore
// TODO: refactor without type assertion, or add comment
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const SelectBox = styled(MuiSelect as any, {
  // @ts-ignore
  shouldForwardProp: (prop) =>
    ![
      'helperText',
      'selectSize',
      'isUnstyled',
      'itemsMinWidth',
      'type',
    ].includes(String(prop)),

  // @ts-ignore
})<Partial<MBSelectProps>>`
  & .MuiSelect-select {
    padding-top: 0;
    padding-bottom: 0;
    padding-right: ${pxToEm(36)} !important;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: ${(props) =>
      props.selectSize != null
        ? selectSizes.height[props.selectSize] + '!important'
        : 'auto'};
    ${(props) => (props.selectSize === 'large' ? 'padding-left: 20px' : '')};

    .MuiListItemText-root {
      margin-bottom: unset;
    }
    &.MuiSelect-outlined {
      background: transparent;
      font-weight: 400;
      transition: background 0.15s ease-in-out;
    }
    &.MuiSelect-standard {
      & ~ [class*='Icon'] svg {
        right: ${pxToEm(12)};
      }
    }
    & ~ [class*='Icon'] svg {
      transform-origin: center;
    }
    &[aria-expanded='true'] {
      & ~ [class*='Icon'] svg {
        transform: rotate(180deg);
      }
    }
  }
  ${(props) =>
    props.type === 'text' &&
    `
    height: ${pxToEm(48)};
    .MuiSelect-select.MuiSelect-select {
      font-size: 10px;
      line-height: ${pxToEm(18)};
      min-width: ${pxToEm(48)}; !important;
      padding-right: ${pxToEm(32)} !important;
      &.MuiSelect-standard {
        & ~ [class*='Icon'] svg {
          right: 0px;
        }
      }
    }
    &::before,
    &::after {
      display: none;
    }
    .MuiSelect-select:focus {
      background: transparent;
    }
    & > [role='button'] {
      height: ${pxToEm(48)}; !important;
    }
  `}
`;
